<nz-space class="mobile-report-control">
  <app-paymentref-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="referenceNo">
  </app-paymentref-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-paymentref-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="referenceNo"></app-paymentref-select>
</nz-space>
